export default {
  'movementWorkOrdersReport.form.selectReportType':
    'Selecione o tipo de relatório',
  'movementWorkOrdersReport.form.selectReportType.totalPerBudget':
    'Total por orçamento',
  'movementWorkOrdersReport.form.selectReportType.insurerAndPrivate':
    'Seguradora/Particular',
  'movementWorkOrdersReport.form.selectReportType.estimators': 'Orçamentistas',
  'movementWorkOrdersReport.form.selectReportType.ServicesAndPartsPerVehicle':
    'Serviços/Peças por veiculo',
  'movementWorkOrdersReport.form.selectReportType.osCost': 'Custo da OS',
  'movementWorkOrdersReport.form.selectReportType.partStatus': 'Status da Peça',
  'movementWorkOrdersReport.form.selectReportType.osByArea': 'OS por area',

  'movementWorkOrdersReport.form.filterByDate': 'Filtrar por data de',
  'movementWorkOrdersReport.form.filterByDate.entrance': 'Entrada',
  'movementWorkOrdersReport.form.filterByDate.authorization': 'Autorização',
  'movementWorkOrdersReport.form.filterByDate.shutdown': 'Fechamento',
  'movementWorkOrdersReport.form.filterByDate.expectedDeparture':
    'Saída prevista',
  'movementWorkOrdersReport.form.filterByDate.delivery': 'Entrega',

  'movementWorkOrdersReport.form.situation': 'Situação',
  'movementWorkOrdersReport.form.situation.open': 'Abertos',
  'movementWorkOrdersReport.form.situation.authorized': 'Autorizados',
  'movementWorkOrdersReport.form.situation.closed': 'Fechados',
  'movementWorkOrdersReport.form.situation.canceled': 'Cancelados',

  'movementWorkOrdersReport.form.budgetType': 'Tipo de Orçamento',
  'movementWorkOrdersReport.form.budgetType.budget': 'Orçamento',
  'movementWorkOrdersReport.form.budgetType.assurance': 'Garantia',
  'movementWorkOrdersReport.form.budgetType.return': 'Retorno',
  'movementWorkOrdersReport.form.budgetType.courtesy': 'Cortesia',
  'movementWorkOrdersReport.form.budgetType.insideCourtesy':
    'Interna (Cortesia)',
  'movementWorkOrdersReport.form.budgetType.totalLoss': 'Perda Total',
  'movementWorkOrdersReport.form.budgetType.revision': 'Revisão',

  'movementWorkOrdersReport.form.synthetic': 'Sintetico?',
  'movementWorkOrdersReport.form.particular': 'Gerar com dados de particular?',
  'movementWorkOrdersReport.form.insurer': 'Gerar com dados de seguradora?',

  'movementWorkOrdersReport.form.moreOptions': 'Mais Opções',
  'movementWorkOrdersReport.form.moreOptions.estimators': 'Orçamentistas',
  'movementWorkOrdersReport.form.moreOptions.button.selectCustomers':
    'Selecionar Clientes',
  'movementWorkOrdersReport.form.moreOptions.button.selectVehicles':
    'Selecionar Veículos',
  'movementWorkOrdersReport.form.moreOptions.button.selectBrands':
    'Selecionar Montadoras',
  'movementWorkOrdersReport.form.moreOptions.button.selectModels':
    'Selecionar Modelos',

  'movementWorkOrdersReport.form.checkbox.parts': 'Peças',
  'movementWorkOrdersReport.form.checkbox.partsProvided': 'Peças fornecidas',
  'movementWorkOrdersReport.form.checkbox.tasks': 'Serviços',
  'movementWorkOrdersReport.form.checkbox.third': 'Terceiro',
  'movementWorkOrdersReport.form.checkbox.benefits': 'Benefícios',
  'movementWorkOrdersReport.form.filterServiceAndPartDescription':
    'Filtrar pela descrição do serviço/peça:',
};
